const Home = () => {
  return (
    <div className="container text-center">
      <h1 className="my-5">Our mission</h1>
      <h6 className="w-75 mx-auto">
        People in war need support ,need to talk through that terrible
        situation. One small talk may significantly improve one's psychological
        state. We as humans may help each other.
      </h6>
      <img src="./talk.gif" className="m-3 w-75"/>
    </div>
  );
};

export default Home;
